import { ArrowRight, Timer, Flame } from "lucide-react";
import { Link } from "react-router-dom";

export default function TestCTA() {
    return (
        <section data-testid="test-cta-section" className="py-20 sm:py-28 bg-white">
            <div className="container-narrow">
                <div className="relative rounded-[2rem] overflow-hidden bg-gradient-to-br from-brand-500 via-brand-600 to-brand-700 px-8 sm:px-14 py-14 sm:py-20 text-white">
                    <div className="absolute -top-24 -right-24 h-[280px] w-[280px] rounded-full bg-white/10 blur-3xl" />
                    <div className="absolute -bottom-24 -left-24 h-[280px] w-[280px] rounded-full bg-pinky-400/20 blur-3xl" />
                    <div className="relative max-w-2xl">
                        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-100">
                            <Timer className="h-4 w-4" strokeWidth={2} /> Seulement 3 minutes
                        </span>
                        <h2 className="display-2 mt-4 !text-white">
                            Faites le test gratuit maintenant.
                        </h2>
                        <p className="mt-5 text-lg leading-relaxed text-brand-50/90">
                            Découvrez le profil neuro-éducatif de votre enfant et recevez immédiatement votre
                            plan d'action personnalisé.
                        </p>
                        <Link
                            to="/test"
                            data-testid="test-cta-button"
                            className="mt-10 relative inline-flex items-center justify-center rounded-full bg-white text-brand-700 font-semibold px-7 py-3.5 shadow-lg transition-all animate-fire-glow hover:-translate-y-0.5"
                        >
                            <Flame className="mr-2 h-4 w-4 animate-fire-flicker text-pinky-500" strokeWidth={2.5} />
                            Lancer le test
                            <ArrowRight className="ml-2 h-4 w-4" strokeWidth={2.5} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
